import { jwtDecode } from "jwt-decode";

// Get Roles based on jwt token
export const getRolesByToken: (token?: string) => string[] = (token?: string) => {
  return (jwtDecode(token || '') as { roles?: string[] }).roles ?? [];
}